import { gql, TypedDocumentNode } from '@common/hooks';
import { SubmittalPacketInfoType } from 'works/graphql/submittal-packet';

export const SUBMITTAL_PACKET_QUERY: TypedDocumentNode<{
  worksSubmittalPacket: SubmittalPacketInfoType;
}> = gql`
  query WorksSubmittalPacketPreviewerDrawerQuery($id: ID!) {
    worksSubmittalPacket(id: $id) {
      id
      files {
        id
        filename
        downloadUrl
        createdAt
      }
    }
  }
`;
